import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '@/views/NotFound.vue'

import CampaignsList from '@/views/Campaigns/CampaignsList.vue'
import CampaignDetail from '@/views/Campaigns/CampaignDetail.vue'
import CampaignInfo from '@/views/Campaigns/CampaignInfo.vue'
import CampaignVoting from '@/views/Campaigns/CampaignVoting.vue'
import CampaignNews from '@/views/Campaigns/CampaignNews.vue'

import EventsList from '@/views/Events/EventsList.vue'
import EventDetail from '@/views/Events/EventDetail.vue'
import EventSection from '@/views/Events/EventSection.vue'
import EventNews from '@/views/Events/EventNews.vue'
import EventCheckIn from '@/views/Events/EventCheckIn.vue'
import EventVoting from '@/views/Events/EventVoting.vue'

import ElectionsList from '@/views/Elections/ElectionsList.vue'
import ElectionDetail from '@/views/Elections/ElectionDetail.vue'
import ElectionRegistration from '@/views/Elections/ElectionRegistration.vue'
import ElectionSection from '@/views/Elections/ElectionSection.vue'
import ElectionRegistrationConfirm from '@/views/Elections/ElectionRegistrationConfirm.vue'
import ElectionVoting from '@/views/Elections/ElectionVoting.vue'

import NCCampaignsList from '@/components/NationalCouncil/NCCampaignsList.vue'
import NCCampaignDetail from '@/components/NationalCouncil/NCCampaignDetail.vue'
import NCCampaignInvite from '@/components/NationalCouncil/NCCampaignInvite.vue'

import SubmitCampaign from '@/views/Campaigns/SubmitCampaign.vue'

import QuestionnaireList from '@/views/Voting/QuestionnaireList.vue'
import QuestionnaireDetail from '@/views/Voting/QuestionnaireDetail.vue'

import NewsList from '@/views/News/NewsList.vue'
import Article from '@/views/News/Article.vue'
import Registration from '@/views/User/Registration.vue'
import SuccessfulRegistration from '@/views/User/SuccessfulRegistration.vue'
import ForgottenPassword from '@/views/User/ForgottenPassword.vue'
import UpdatePassword from '@/views/User/UpdatePassword.vue'
import Profile from '@/views/User/Profile.vue'
import Login from '@/views/User/Login.vue'
import TokenLogin from '@/views/User/TokenLogin.vue'
import Page from '@/views/Pages/Page.vue'

export function createRouter () {
  Vue.use(Router)

  const router = new Router({
    mode: 'history',
    scrollBehavior () {
      return { x: 0, y: 0 }
    },
    routes: [
      {
        path: '/',
        redirect: '/новини',
        meta: { title: 'Новини' }
      },
      {
        path: '/кампании',
        alias: encodeURI('/кампании'),
        name: 'campaigns',
        component: CampaignsList,
        meta: { title: 'Кампании' }
      },
      {
        path: '/кампании/:slug',
        alias: encodeURI('/кампании/:slug'),
        name: 'campaign',
        component: CampaignDetail,
        children: [
          {
            path: '',
            alias: encodeURI(''),
            component: CampaignInfo,
            name: 'campaign-info',
            meta: { hero: true, tabs: true, back: 'campaigns' },
          },
          { path: 'новини',
            alias: encodeURI('новини'),
            component: CampaignNews,
            name: 'campaign-news',
            meta: { hero: true, tabs: true, back: 'campaigns' },
          },
          { path: 'гласуване',
            alias: encodeURI('гласуване'),
            component: CampaignVoting,
            name: 'campaign-voting',
            meta: { hero: true, tabs: true, back: 'campaigns' },
          }
        ]
      },
      {
        path: '/предложи-кампания',
        alias: encodeURI('/предложи-кампания'),
        component: SubmitCampaign,
        name: 'submit-campaign',
        meta: { title: 'Предложи кампания' }
      },

      {
        path: '/събития',
        alias: encodeURI('/събития'),
        name: 'events',
        component: EventsList,
        meta: { title: 'Събития', tabs: true }
      },

      {
        path: '/събития/отминали',
        alias: encodeURI('/събития/отминали'),
        name: 'events-past',
        component: EventsList,
        meta: { title: 'Събития', tabs: true }
      },

      {
        path: '/събития/:slug',
        alias: encodeURI('/събития/:slug'),
        name: 'event',
        component: EventDetail,
        meta: { back: 'events', tabs: true, hero: true },
        children: [
          { path: 'покана',
            alias: encodeURI('покана'),
            component: EventSection,
            name: 'event-invite',
            meta: { back: 'events', tabs: true, hero: true }
          },
          { path: 'дневен-ред',
            alias: encodeURI('дневен-ред'),
            component: EventSection,
            name: 'event-agenda',
            meta: { back: 'events', tabs: true, hero: true }
          },
          { path: 'предложения',
            alias: encodeURI('предложения'),
            component: EventSection,
            name: 'event-proposals',
            meta: { back: 'events', tabs: true, hero: true }
          },
          { path: 'номинации',
            alias: encodeURI('номинации'),
            component: EventSection,
            name: 'event-nominations',
            meta: { back: 'events', tabs: true, hero: true }
          },
          { path: 'гласуване',
            alias: encodeURI('гласуване'),
            component: EventVoting,
            name: 'event-voting',
            meta: { back: 'events', tabs: true, hero: true }
          },
          {
            path: 'checkin',
            component: EventCheckIn,
            name: 'checkin',
            meta: { back: 'events', tabs: true, hero: true }
          },
          { path: 'новини',
            alias: encodeURI('новини'),
            component: EventNews,
            name: 'event-news',
            meta: { hero: true, tabs: true, back: 'events' },
          }
        ]
      },

      {
        path: '/избори',
        alias: encodeURI('/избори'),
        name: 'elections',
        component: ElectionsList,
        meta: { title: 'Избори' }
      },

      {
        path: '/избори/:slug',
        alias: encodeURI('/избори/:slug'),
        name: 'election',
        component: ElectionDetail,
        meta: { tabs: true, back: 'elections' },
        children: [
          {
            path: 'регистрация/:code?',
            alias: encodeURI('регистрация/:code?'),
            component: ElectionRegistration,
            name: 'election-registration',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'регистрация/потвърди/:token',
            alias: encodeURI('регистрация/потвърди/:token'),
            component: ElectionRegistrationConfirm,
            name: 'election-registration-confirm',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'кандидати',
            alias: encodeURI('кандидати'),
            component: ElectionSection,
            name: 'election-candidates',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'правила',
            alias: encodeURI('правила'),
            component: ElectionSection,
            name: 'election-rules',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'гласуване',
            alias: encodeURI('гласуване'),
            component: ElectionVoting,
            name: 'election-voting',
            meta: { requiresAuth: true, tabs: true, back: 'elections' },
          }
        ]
      },

      {
        path: '/национален-съвет',
        alias: encodeURI('/национален-съвет'),
        name: 'national-council',
        component: NCCampaignsList,
        meta: { title: 'Национален съвет' }
      },
      {
        path: '/национален-съвет/:slug',
        alias: encodeURI('/национален-съвет/:slug'),
        name: 'nc-campaign',
        component: NCCampaignDetail,
        meta: { title: 'Национален съвет' },
        children: [
          { path: 'предложения', alias: encodeURI('предложения'), component: CampaignNews, name: 'nc-campaign-news' },
          { path: 'предложения/:articleSlug', alias: encodeURI('предложения/:articleSlug'), component: Article, name: 'nc-campaign-article' },
          { path: 'покана', alias: encodeURI('покана'), component: NCCampaignInvite, name: 'nc-campaign-invite' },
          { path: 'дневен-ред', alias: encodeURI('дневен-ред'), component: CampaignInfo, name: 'nc-campaign-info' },
          { path: 'гласуване', alias: encodeURI('гласуване'), component: CampaignVoting, name: 'nc-campaign-voting' }
        ]
      },

      {
        path: '/анкети',
        alias: encodeURI('/анкети'),
        name: 'questionnaires',
        component: QuestionnaireList,
        meta: { title: 'Анкети' }
      },

      {
        path: '/анкети/:id',
        alias: encodeURI('/анкети/:id'),
        name: 'questionnaire',
        component: QuestionnaireDetail,
        meta: { back: 'questionnaires' }
      },

      {
        path: '/новини',
        alias: encodeURI('/новини'),
        name: 'news',
        component: NewsList,
        meta: { title: 'Новини' }
      },
      {
        path: '/новини/:slug',
        alias: encodeURI('/новини/:slug'),
        name: 'article',
        component: Article,
        meta: { hero: true, back: 'news' }
      },
      {
        path: '/вход',
        name: 'login',
        alias: encodeURI('/вход'),
        component: Login,
        meta: { title: 'Вход' }
      },
      {
        path: '/регистрация',
        name: 'registration',
        alias: encodeURI('/регистрация'),
        component: Registration,
        meta: { title: 'Регистрация' }
      },
      {
        path: '/регистрация/потвърди',
        alias: encodeURI('/регистрация/потвърди'),
        component: SuccessfulRegistration,
        meta: {
          title: 'Регистрация',
          confirmed: false
        }
      },
      {
        path: '/регистрация/успех',
        alias: encodeURI('/регистрация/успех'),
        component: SuccessfulRegistration,
        meta: {
          title: 'Регистрация',
          confirmed: true
        }
      },
      {
        path: '/забравена-парола',
        alias: encodeURI('/забравена-парола'),
        component: ForgottenPassword,
        meta: { title: 'Забравена парола' },
        name: 'forgot-pass'
      },
      {
        path: '/забравена-парола/потвърди',
        alias: encodeURI('/забравена-парола/потвърди'),
        component: ForgottenPassword,
        meta: {
          title: 'Забравена парола',
          sent: true
        }
      },
      {
        path: '/забравена-парола/потребител/:id/token/:token',
        alias: encodeURI('/забравена-парола/потребител/:id/token/:token'),
        component: UpdatePassword,
        meta: { title: 'Забравена парола' },
      },
      {
        path: '/вход/token/:token/:redirect?',
        alias: encodeURI('/вход/user/:email/token/:token/:redirect?'),
        component: TokenLogin
      },
      {
        path: '/профил',
        name: 'profile',
        alias: encodeURI('/профил'),
        component: Profile,
        meta: {
          title: 'Профил',
          requiresAuth: true
        }
      },
      {
        path: '/за-нас',
        alias: encodeURI('/за-нас'),
        name: 'about',
        component: Page,
        meta: { title: 'За нас', hero: true },
      },
      {
        path: '/404',
        name: '404',
        component: NotFound,
        meta: { title: 'Несъществуваща страница' },
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  })

  return router
}
